import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const error = params.get("error");

  useEffect(() => {
    if (!loading && user) navigate("/", { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F7F3] px-4" data-testid="login-page">
      <div className="card-surface p-10 w-full max-w-md text-center fade-up">
        <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center font-heading font-bold text-white text-lg mx-auto mb-5 shadow-[0_8px_24px_rgba(59,130,246,0.35)]">
          HB
        </div>
        <h1 className="font-heading text-2xl font-bold text-zinc-900">Harkaran Boparai Studio</h1>
        <p className="text-[11px] uppercase tracking-widest text-zinc-400 mt-1 mb-8">Capital Reserve System</p>

        {error === "denied" && (
          <div className="mb-6 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3" data-testid="login-denied-error">
            This Google account is not authorised. Access is restricted to approved HBS Studio accounts only.
          </div>
        )}
        {error === "failed" && (
          <div className="mb-6 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3" data-testid="login-failed-error">
            Sign-in failed. Please try again.
          </div>
        )}

        <Button data-testid="google-login-btn" onClick={signIn}
          className="w-full h-12 bg-zinc-900 hover:bg-zinc-800 text-white font-semibold text-sm gap-3">
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.06H2.18A11 11 0 0 0 1 12c0 1.77.43 3.45 1.18 4.94l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 12 1 11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Sign in with Google
        </Button>

        <div className="mt-8 pt-6 border-t border-[#ECE9E1] flex items-center justify-center gap-2 text-xs text-zinc-400">
          <ShieldCheck size={13} className="text-blue-600" />
          Access limited to approved studio accounts
        </div>
      </div>
    </div>
  );
}
